import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { CommentsList } from '@widgets/shared/Comments/CommentsList/index.tsx';
import { useUser } from '@shared/hooks/index.ts';
import { useArticleQuery } from '@src/api/api-hooks/articles/useArticleQuery.ts';
import { Loader } from '@src/library/components/common/index.ts';

type PT = {};
export const ArticleComments = ({}: PT) => {
  const { articleId } = useParams();
  const { data } = useArticleQuery({ id: articleId });
  const { user, isAuth } = useUser();
  const isContentAuthor = useMemo(() => user?.id === data?.author.id, [data, user]);
  return data ? (
    <CommentsList
      isPaid={isAuth}
      isContentAuthor={isContentAuthor}
      comments={data.comments}
      article={Number(articleId)}
    />
  ) : (
    <Loader />
  );
};
